module.exports = __webpack_public_path__ + "static/media/logo-3.29d99a00.jpg";